import '../../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.filter.js';
import '../../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.join.js';
import '../../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.map.js';
import '../../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import React from 'react';
import { Picker } from 'antd-mobile';
import { RightOutline } from 'antd-mobile-icons';
import './index.less.js';
import { isFunction } from 'lodash';
import useLanguage from '../../../../hooks/useLangugle/index.js';
import classNames from 'classnames';

var PickerWrap = function PickerWrap(props) {
  var _a;
  var locale = useLanguage('Common');
  var _b = props.placeholder,
    placeholder = _b === void 0 ? locale['pleaseSelect'] : _b,
    value = props.value,
    onChange = props.onChange,
    disabled = props.disabled,
    _c = props.columns,
    columns = _c === void 0 ? [] : _c;
  var onConfirm = function onConfirm(v) {
    if (isFunction(onChange)) {
      onChange(v[0]);
    }
  };
  var pickerCls = classNames((_a = {}, _a['ti-form-picker'] = true, _a['ti-form-picker-disabled'] = disabled, _a));
  var pickerStyle = {
    '--ti-placeholder-color': '#9EA1A7'
  };
  return /*#__PURE__*/React.createElement(Picker, {
    value: [value],
    onConfirm: onConfirm,
    columns: columns
  }, function (items, actions) {
    if (items === void 0) {
      items = [];
    }
    var safeItems = items.filter(function (x) {
      return x !== null;
    });
    return /*#__PURE__*/React.createElement("div", {
      style: pickerStyle,
      className: pickerCls,
      onClick: function onClick() {
        if (disabled) {
          return;
        }
        actions.open();
      }
    }, safeItems.length === 0 ? /*#__PURE__*/React.createElement("div", {
      className: "ti-form-picker-placeholder"
    }, placeholder) : /*#__PURE__*/React.createElement("div", {
      className: "ti-form-picker-content"
    }, safeItems.map(function (x) {
      return x === null || x === void 0 ? void 0 : x.label;
    }).join('-')), /*#__PURE__*/React.createElement("div", {
      className: "ti-form-picker-icon"
    }, /*#__PURE__*/React.createElement(RightOutline, {
      color: "#999999"
    })));
  });
};

export { PickerWrap as default };
